<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
// Компонент информации о подключении (логин, статус тарифа, продление)
import PaidUserInterface from '@/components/paid-interface/PaidUserInterface.vue'
// Кнопка "Как подключить VPN" с диалогом (инструкции / онбординг)
import InstructionsButton from '@/components/instructions-button/InstructionsButton.vue'
// Выбор сервера
import ServersDropdown from '@/components/servers-dropdown/ServersDropdown.vue'
import { useApiStore } from '@/modules/api/store/apiStore'
import { REST_LINK_TYPE } from '@/modules/subscription/constants/vpnApps'
import { copyToClipboard } from '@/utils/CopyToClipboard'

// В vpn-box серверы скрыты (в vpn-mobile — свой экран).
const showServersDropdown = false

const apiStore = useApiStore()
const { t } = useI18n()

const restLink = computed(
  () => apiStore.subscriptionLinks.find((link) => link.type === REST_LINK_TYPE)?.url ?? '',
)

const copyKeyLink = () => {
  if (restLink.value) copyToClipboard(restLink.value)
}

onMounted(async () => {
  if (apiStore.subscriptionLinks.length === 0) await apiStore.getSubscriptionLinks()
})
</script>

<template>
  <div class="d-flex flex-column ga-4 w-100">
    <paid-user-interface />

    <div class="d-flex flex-column ga-2">
      <div class="text-body-1">{{ t('common.copySubscriptionLink') }}</div>

      <VBtn
        data-onboarding="copy-link"
        variant="flat"
        color="surface"
        class="text-on-surface"
        rounded="lg"
        block
        prepend-icon="ri-link"
        :disabled="!restLink"
        @click="copyKeyLink"
      >
        {{ t('profile.copyLink') }}
      </VBtn>
    </div>

    <instructions-button />
    <servers-dropdown v-if="showServersDropdown" />
  </div>
</template>

<style scoped></style>
